// Angular dependencies.
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { downgradeInjectable } from '@angular/upgrade/static';

// Shared modules
import { CoreModule } from '../core';

// App module dependencies.
import { AuthGuard } from './auth.guard';

import { AuthService } from './auth.service';
@NgModule({
    imports: [
        CommonModule,
        CoreModule
    ],
    providers: [
        AuthGuard,
        AuthService
    ],
    declarations: []
})
export class AuthModule { }

declare const angular: angular.IAngularStatic;

angular.module('app')
    .factory('AuthService', downgradeInjectable(AuthService) as any);
